import styled from 'styled-components';
import { useCallback, useState } from 'react';
import ConditionalRenderer from './conditional-renderer';
const WidgetWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`;

const Button = styled.button`
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    background-color: #02BD7E !important;
    transition: all .5s ease-in-out;
    border-radius: 100px !important;
    padding: 10px 46px 10px 20px;
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 16px;
    font-weight: inherit !important;
    text-decoration: none;
    position: relative;
    border: transparent !important;
    color: #ffffff !important;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        cursor: pointer !important;
    }
`;

const CloseButton = styled.button`
    padding: 1px;
    border-radius: 100px;
    position: relative;
    opacity: .25;
    transition: all .5s ease-in-out;
    border: transparent;
    background: transparent!important;
    background-color: transparent!important;
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
`;

const CloseButtonCount = styled.span`
    margin-left: 7px;
    color: #ffffff !important;
`

const CloseIcon = styled.span`
    position: absolute;
    top: -12px;
    right: 12px;
    background: transparent!important;
    background-color: transparent!important;
`;

const FloatingWidgetWrapper = styled.div`
    position: fixed;
    z-index: 9999999;
    bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0; 
    left:0;
`;

const FloatingEmailWidget = () => {
    const [isRendered, setIsRendered] = useState(true);
    const closeWidget = useCallback(() => { setIsRendered(false); }, [isRendered]);
    const openEmail = useCallback(() => {
        window.open('https://web.phone.email', '_blank');
    }, []);

    return (
        <ConditionalRenderer condition={isRendered}>
            <FloatingWidgetWrapper>
                <WidgetWrapper>
                    <Button onClick={openEmail}>
                        <span style={{ marginTop: '1px' }}>
                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.9432 2.46724C16.5877 2.46724 15.2438 2.46724 13.8953 2.46724C13.8705 2.3405 13.8512 2.20921 13.8188 2.08146C13.7615 1.85587 13.6865 1.63586 13.5405 1.44931C13.4173 1.29267 13.2647 1.20902 13.0548 1.20953C10.3402 1.21257 7.62608 1.21359 4.91144 1.20598C4.64226 1.20548 4.47193 1.32258 4.3457 1.536C4.19971 1.78237 4.13381 2.0551 4.09072 2.33493C4.08311 2.38359 4.07804 2.43327 4.07095 2.49005C2.72047 2.49005 1.37203 2.49005 0.0154701 2.49005C0.0134424 2.45456 0.0104008 2.42111 0.0104008 2.38815C0.00887996 2.24266 0.0210464 2.09565 0.00381062 1.95168C-0.0215361 1.73624 0.0818785 1.60038 0.245111 1.48784C0.533557 1.28861 0.856474 1.16188 1.18497 1.05238C2.0645 0.759374 2.96481 0.550517 3.88186 0.419221C4.61996 0.313272 5.36059 0.225572 6.10173 0.144462C6.53566 0.0973176 6.97213 0.0669015 7.40809 0.0516935C8.19435 0.0238121 8.98111 -0.0040693 9.76787 0.00049311C10.4426 0.00454859 11.1183 0.0349647 11.7911 0.0886997C13.3423 0.211885 14.8727 0.466873 16.3671 0.911961C16.797 1.04022 17.2234 1.18013 17.6117 1.41332C17.6725 1.44982 17.7303 1.49189 17.7866 1.53549C17.895 1.61964 17.9544 1.72306 17.9462 1.87007C17.9351 2.06473 17.9432 2.2599 17.9432 2.46724Z" fill="white" />
                                <path d="M13.9219 2.57422C15.2911 2.57422 16.6385 2.57422 18.0002 2.57422C18.0002 2.73897 18.0022 2.89866 17.9976 3.05834C17.9971 3.08267 17.9692 3.11208 17.9464 3.12931C17.8537 3.2013 17.7502 3.24287 17.6296 3.24236C16.5666 3.23982 15.504 3.23982 14.441 3.23628C14.371 3.23628 14.2985 3.22107 14.2326 3.19775C14.186 3.18153 14.1272 3.14807 14.111 3.10701C14.042 2.93668 13.9868 2.76026 13.9219 2.57422Z" fill="white" />
                                <path d="M0.0179092 2.59766C1.35469 2.59766 2.6854 2.59766 4.03131 2.59766C3.99582 2.70208 3.94716 2.79942 3.93093 2.90232C3.89089 3.15579 3.72664 3.24298 3.497 3.25616C3.45999 3.25819 3.42299 3.26073 3.38547 3.26073C2.38478 3.26073 1.3846 3.26123 0.383916 3.25971C0.326125 3.25971 0.2658 3.25211 0.211051 3.23386C0.0599847 3.18317 0.01943 3.12233 0.0184161 2.96265C0.0168953 2.84301 0.0179092 2.72338 0.0179092 2.59766Z" fill="white" />
                                <path d="M8.99958 8.61405L0 13.8101V3.41797L8.98843 8.60746L8.99958 8.61405Z" fill="white" />
                                <path d="M9 8.61405L18.0001 13.8101V3.41797L9 8.61405Z" fill="white" />
                                <path d="M17.9997 13.8152H0L8.99959 8.61914L9.01125 8.62573L17.9997 13.8152Z" fill="white" />
                                <path d="M9.01126 8.62256L0.0299091 13.812H0V13.7948L8.98845 8.60938L8.9996 8.61597L9.01126 8.62256Z" fill="#F5F5F5" />
                            </svg>
                        </span>
                        <CloseButtonCount>Unread Emails (2)</CloseButtonCount>
                    </Button>
                    <CloseButton onClick={closeWidget}>
                        <CloseIcon>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="#92E3A9" />
                            </svg>
                        </CloseIcon>
                    </CloseButton>
                </WidgetWrapper>
            </FloatingWidgetWrapper>
        </ConditionalRenderer>
    );
};

export default FloatingEmailWidget;
